<template>
  <div id="app" class="app" :class="{'h':$store.getters.device.isLaptop,'is-ie':$store.getters.device.isIE,'header-fixed':scrollPos>1}">
    <!-- <app-header class="app__header" :class="{'is-up':!headerDown&&!$store.getters.device.isLaptop}"/> -->
    <app-header class="app__header" :class="{'is-up':!headerDown}"
    />
    <app-page class="app__page" @scroll.native="trackScroll($event)"
    />
    <app-nav class="app__nav" />
    <!-- <app-navicon class="app__navicon" :class="{'is-up':!headerDown&&!$store.getters.device.isLaptop}"/> -->
    <app-navicon class="app__navicon" :class="{'is-up':!headerDown}"
    />
    <app-gate class="app__gate" />
    <transition name="modal">
      <map-modal class="app__modal" />
    </transition>
    <transition name="modal">
      <search-modal class="app__modal" />
    </transition>
    <app-cookies class="app__cookies" />
    <app-loader class="app__loader" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import AppGate from '@/partials/AppGate'
import AppHeader from '@/partials/AppHeader'
import AppNavicon from '@/partials/AppNavicon'
import AppNav from '@/partials/AppNav'
import AppPage from '@/partials/AppPage'
import AppLoader from '@/partials/AppLoader'
import AppCookies from '@/partials/AppCookies'
import MapModal from '@/partials/MapModal'
import SearchModal from '@/partials/SearchModal'

import '@/assets/less/index.less'

export default {
  name: 'App',
  components: {
    AppLoader,
    AppCookies,
    AppGate,
    AppHeader,
    AppNavicon,
    AppNav,
    MapModal,
    SearchModal,
    AppPage
  },
  computed: {
    ...mapGetters(['activeModal'])
  },
  data() {
    return {
      headerDown: true,
      scrollPos: 0,
      scrollPosLast: 0,
      scrollSpeed: 0
    }
  },
  methods: {
    ...mapActions(['openModal', 'closeModal']),
    trackScroll(e) {
      this.scrollPos = e.target.scrollTop
      if (this.scrollPosLast !== null) {
        this.scrollSpeed = this.scrollPos - this.scrollPosLast
      }
      this.scrollPosLast = this.scrollPos
      this.headerDown = this.scrollSpeed <= 0 || this.scrollPos === 0
      clearTimeout(this.scrollTimer)
      this.scrollTimer = setTimeout(() => {
        this.scrollPosLast = null
        this.scrollSpeed = 0
      }, 50)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue